import { h, Component } from 'preact'
import TrackingLink from '../link/tracking-link'
import Phrase from '../../libs/translationsUtils/phrase'
import LazyLoader from '../lazy-loading/LazyLoader'
import Icon from '../assets'
import { z } from 'zod'
import { GetServerSideProps } from '../../server-middleware/context'
import UserApi from '../../services/api'
import { getAttachment } from '../../server-middleware/attachmentRepository'

export const widgetName = 'badges'

export const config = z.object({
  title: z.string(),
  amount: z.number().default(5)
})

interface Props {
  title: string
  badges: Array<{
    title: string
    image: string
    username: string
    userUrl: string
  }>
}

export const getServerSideProps: GetServerSideProps<z.infer<typeof config>, Props> = async (context, config) => {
  const api = new UserApi(context)
  return await context.cache(`badgesEarned-Widget${config.amount}`, async () => {
    const latestBadgeAssignments = await api.getLatestBadgeAssignments(config.amount)
    return {
      title: config.title,
      badges: await Promise.all(latestBadgeAssignments.map(async assignment => {
        const attachment = await getAttachment(context, parseInt(assignment._related.badges.imageAttachmentId))

        return {
          title: assignment._related.badges.title,
          image: attachment ? `${context.config.config.params.uploadCdn}/${context.communityId}/attachment/${attachment.source}` : '',
          username: assignment._related.user.username,
          userUrl: `/member/m-${assignment._related.user.userid}`
        }
      }))
    }
  })
}

export default class BadgesEarned extends Component<Props> {
  render (props: Props) {
    if (!props.badges.length) return null
    return (
      <div class='box widget widget--badges qa-widget-badges'>
        <div class='box__content box__pad'>
          {props.title ? <h3 class='widget-title'>{props.title}</h3> : null}
          <TrackingLink
            tag='ul'
            track={{ type: 'Sidebar Widget Clicked', widget: 'badges' }}
            gaEvents={{ eventCategory: 'Homepage', eventAction: 'Widget Clicked', eventLabel: { Type: 'Badges' } }}
            class='list list--badges unpad--sidebar qa-badges-earned-list'
          >
            {props.badges.map((badge, index) => {
              return (
                <li key={index}>
                  <div class='user flag flag--top'>
                    <div class='flag__image'>
                      <LazyLoader type='img' src={badge.image} title={badge.title} alt={badge.title} />
                    </div>
                    <div class='user_data flag__body'>
                      <a class='link username' href={badge.userUrl}>{badge.username}</a>
                      <span class='text--meta'><Phrase p='has earned the badge {badgetitle}' count={{ badgetitle: badge.title }} /></span>
                    </div>
                  </div>
                </li>
              )
            })}
          </TrackingLink>
          <a className='btn--cta btn--show-more link link--underline' href='/badges'><Phrase p='Show all badges' />
            <Icon customClass='badges-link-text-icon' icon='chevronRight' height={20} width={20} />
          </a>
        </div>
      </div>
    )
  }
}
